import { useSettings } from '@/access/SettingsContext';

/**
 * הלוגו לא מקודד בקוד: הנתיב מגיע מ app_settings (brand.logo_white / brand.logo_ink),
 * עם נפילה חזרה לקבצים שב public/brand. שם האפליקציה גם הוא מההגדרות.
 */
export function Logo({ on = 'charcoal', height = 28 }: { on?: 'charcoal' | 'surface'; height?: number }) {
  const { brand } = useSettings();
  const src =
    on === 'charcoal'
      ? (brand.logo_white ?? '/brand/logo-white.svg')
      : (brand.logo_ink ?? '/brand/logo-ink.svg');

  return <img src={src} alt={brand.app_title} style={{ height }} className="w-auto select-none" />;
}
